import * as tslib_1 from "tslib";
// Core packages
import { HttpResponse } from '@angular/common/http';
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
// Custom packages
import { DocumentArchivesService } from 'src/app/modules/properties/document-archives.service';
import { canDownloadDocFilesZip, fallbackZipFileName, skippedFilesCount, skippedFilesMessage, SKIPPED_FILES_HEADER, zipDownloadErrorMessage, zipFileNameFromContentDisposition, } from 'src/app/modules/properties/document-files-zip.utils';
import { ConfigService } from 'src/app/shared/services/config.service';
var DocumentDownloadDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function DocumentDownloadDialogComponent(dialogRef, data, configService, cookieService, translateService, documentArchivesService, toastrService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.documentArchivesService = documentArchivesService;
        this.toastrService = toastrService;
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.send'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paper-plane',
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
        /** True when "Scarica tutti" is offered: see `canDownloadDocFilesZip` */
        this.canDownloadAll = false;
        /** True while the zip downloads: the button is disabled, so a second click asks for nothing */
        this.zipDownloading = false;
        this.subscriptions = [];
    }
    /**
     * Init component
     *
     */
    DocumentDownloadDialogComponent.prototype.ngOnInit = function () {
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        this.initForm();
        this.canDownloadAll = canDownloadDocFilesZip(this.data);
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Destroy component
     *
     */
    DocumentDownloadDialogComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    DocumentDownloadDialogComponent.prototype.initForm = function () {
        // Set model
        this.model = this.data; //.documents;
        // Set fields
        this.fields = tslib_1.__spread(this.fields, [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: "col-12 mb-0",
                        type: "file-downloader",
                        key: "documents",
                        hideExpression: function (model) { return !model || model.length === 0; },
                        templateOptions: {
                            label: this.translateService.instant('properties.fields.documents'),
                            required: false,
                            bindLabel: "originalName",
                            readonly: true,
                        }
                    },
                ],
            },
        ]);
    };
    /**
     * Download every file of the document as one zip, built by the back-end.
     *
     * The zip is saved under the name the back-end sends in `Content-Disposition`, and a warning
     * tells how many files it could not include. The dialog stays open, as after a single download.
     *
     * @since 3.0.0
     */
    DocumentDownloadDialogComponent.prototype.onDownloadAll = function () {
        var _this = this;
        if (!this.canDownloadAll || this.zipDownloading) {
            return;
        }
        this.zipDownloading = true;
        this.subscriptions.push(this.documentArchivesService
            .downloadDocFilesZip(this.data.documentArchiveId, this.data.docId)
            .pipe(finalize(function () { return (_this.zipDownloading = false); }))
            .subscribe(function (res) {
            // ApiService emits a failure without status (network down, connection cut once the
            // zip had started) as a value, not as an error
            if (!(res instanceof HttpResponse) || !(res.body instanceof Blob)) {
                console.warn('Scarica tutti: zip download failed', { status: 0 });
                _this.showMessage(zipDownloadErrorMessage(0, null, Date.now()), 'error');
                return;
            }
            var fileName = zipFileNameFromContentDisposition(res.headers.get('Content-Disposition')) ||
                fallbackZipFileName(_this.data.barCode);
            FileSaver.saveAs(res.body, fileName);
            var skipped = skippedFilesMessage(skippedFilesCount(res.headers.get(SKIPPED_FILES_HEADER)));
            if (skipped) {
                _this.showMessage(skipped, 'warning');
            }
        }, function (err) {
            var status = err && typeof err.status === 'number' ? err.status : 0;
            var retryAfter = err && err.headers ? err.headers.get('Retry-After') : null;
            console.warn('Scarica tutti: zip download failed', { status: status });
            _this.showMessage(zipDownloadErrorMessage(status, retryAfter, Date.now()), 'error');
        }));
    };
    /**
     * Show a translated toast of the zip download
     *
     * @since 3.0.0
     */
    DocumentDownloadDialogComponent.prototype.showMessage = function (message, level) {
        var text = this.translateService.instant(message.key, message.params);
        if (level === 'warning') {
            this.toastrService.warning(text);
        }
        else {
            this.toastrService.error(text);
        }
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     */
    DocumentDownloadDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    return DocumentDownloadDialogComponent;
}());
export { DocumentDownloadDialogComponent };
